const MyBiographies = {
  getBiographyData: (type) => ({
    url: `/biography/${type}`,
    method: "GET",
  }),
  deleteMyBiography: (id) => ({
    url: `/biography/${id}`,
    method: "DELETE",
  }),
  deleteSendBiography: (id) => ({
    url: `/biography/remove-users/${id}`,
    method: "DELETE",
  }),
  getHomeBiographyData: {
    url: "/biography",
    method: "GET",
  },
  deleteUser: (id) => ({
    url: `/memorial/user-permission/${id}`,
    method: "DELETE",
  }),
  updatePublishNow: (id) => ({
    url: `/biography/publish-now/${id}`,
    method: "PUT",
  }),
  getLatestData: {
    url: "/latest-biography",
    method: "GET",
  },
  getbiographyCountData: {
    url: "/user-memorial-count",
    method: "GET",
  },
};
export default MyBiographies;
